<template>
  <div class="fomo-phone">
    <label class="fomo-phone__label" :for="id">{{ label }}</label>
    <div class="fomo-phone__controls">
      <div class="fomo-phone__country">
        <select v-model="country" class="form-control checkout-input" aria-label="País del celular" autocomplete="tel-country-code" :disabled="disabled" @change="changeCountry">
          <option v-for="item in countries" :key="item.code" :value="item.code">{{ item.name }} ({{ item.prefix }})</option>
        </select>
        <span class="fomo-phone__selected" aria-hidden="true"><span class="iti__flag" :class="`iti__${country.toLowerCase()}`"></span><span>{{ prefix }}</span><span>⌄</span></span>
      </div>
      <input :id="id" ref="number" class="form-control checkout-input" :value="national" type="tel" inputmode="tel" autocomplete="tel-national" :placeholder="country === 'EC' ? '099 123 4567' : 'Número de celular'" maxlength="40" :required="required" :disabled="disabled" :aria-describedby="`${id}-help`" :aria-invalid="touched && !valid ? 'true' : undefined" @input="input($event.target.value)" @blur="touched = true" />
    </div>
    <small :id="`${id}-help`" :class="{ 'fomo-phone__error': touched && !valid }" aria-live="polite">{{ touched && !valid ? errorMessage : 'Elige el país de tu número. Puedes pegarlo completo con +.' }}</small>
  </div>
</template>
<script>
import { contactPhone, phoneCountries } from '../../common/contactPhone'
import 'intl-tel-input/build/css/intlTelInput.css'

export default {
  name: 'FomoPhoneInput',
  props: {
    modelValue: { type: String, default: '' },
    id: { type: String, required: true },
    label: { type: String, default: 'Celular / WhatsApp' },
    required: Boolean,
    disabled: Boolean,
  },
  emits: ['update:modelValue'],
  data: () => ({ country: 'EC', national: '', touched: false, lastEmitted: null }),
  computed: {
    countries: () => phoneCountries,
    prefix() { return this.countries.find(item => item.code === this.country)?.prefix || '' },
    parsed() { return contactPhone(this.national, this.country) },
    valid() { return !this.national.trim() ? !this.required : this.parsed.valid },
    errorMessage() { return this.national.trim() ? 'Revisa el número y el país seleccionado.' : 'Escribe tu celular para compartir tu WhatsApp.' },
  },
  watch: {
    modelValue(value) { if (value !== this.lastEmitted) this.load(value) },
    valid() { this.updateValidity() },
  },
  mounted() { this.load(this.modelValue); this.updateValidity() },
  methods: {
    load(value) {
      const parsed = contactPhone(value, this.country)
      this.country = parsed.country
      this.national = parsed.national
      this.emitNumber(parsed.number)
    },
    emitNumber(number) { this.lastEmitted = number; if (number !== this.modelValue) this.$emit('update:modelValue', number) },
    input(value) {
      const parsed = contactPhone(value, this.country)
      this.country = parsed.country
      this.national = /^\s*(\+|00)/.test(value) && parsed.valid ? parsed.national : value
      this.emitNumber(parsed.number)
      this.$nextTick(this.updateValidity)
    },
    changeCountry() { this.touched = false; this.emitNumber(contactPhone(this.national, this.country).number); this.$nextTick(this.updateValidity) },
    updateValidity() { this.$refs.number?.setCustomValidity(this.valid ? '' : this.errorMessage) },
    reportValidity() { this.touched = true; this.updateValidity(); return this.$refs.number.reportValidity() },
  },
}
</script>
<style scoped>
.fomo-phone{display:grid;gap:8px;min-width:0;font-family:var(--fomo-font-body);color:inherit}
.fomo-phone__label{font:inherit;margin:0}
.fomo-phone__controls{display:grid;grid-template-columns:126px minmax(0,1fr);gap:8px;align-items:stretch}
.fomo-phone__controls .form-control{width:100%;min-width:0;min-height:48px;margin:0;font-size:16px;font-family:var(--fomo-font-button);box-sizing:border-box}
.fomo-phone__country{position:relative;min-width:0}
.fomo-phone__country select{height:100%;cursor:pointer;color:transparent!important;-webkit-text-fill-color:transparent!important;appearance:none}
.fomo-phone__country option{color:#f1f2f6!important;-webkit-text-fill-color:#f1f2f6!important;background:#101116}
.fomo-phone__selected{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:8px;pointer-events:none;font-family:var(--fomo-font-button);font-size:15px}
.fomo-phone__selected .iti__flag{flex-shrink:0}
.fomo-phone small{font-size:12px;line-height:1.5}
.fomo-phone .fomo-phone__error{color:#ffb9c4}
@media(max-width:480px){.fomo-phone__controls{grid-template-columns:112px minmax(0,1fr)}}
</style>
